import { WebhooksLogo } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import {
  integrationProviderRegistry,
  type IntegrationConfigProps,
  type IntegrationStatusProps,
} from "../integration_registry.js";

function WebhookIcon() {
  return <WebhooksLogo size={20} />;
}

function WebhookConfigEditor({ config, update }: IntegrationConfigProps) {
  const url = (config.url as string) ?? "";
  const secret = (config.secret as string) ?? "";

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="url">Webhook URL</Label>
        <Input
          id="url"
          type="url"
          value={url}
          onChange={e => update({ ...config, url: e.target.value })}
          placeholder="https://example.com/hook"
        />
        <p className="text-xs text-muted-foreground">
          Published posts are sent as JSON via POST to this URL.
        </p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="secret">Bearer token (optional)</Label>
        <Input
          id="secret"
          type="password"
          value={secret}
          onChange={e => update({ ...config, secret: e.target.value })}
          placeholder="shared secret"
        />
      </div>
    </div>
  );
}

function WebhookStatusDisplay({ connected, error }: IntegrationStatusProps) {
  if (connected) {
    return <Badge variant="default">Connected</Badge>;
  }
  return <Badge variant="destructive">{error ?? "Not connected"}</Badge>;
}

integrationProviderRegistry.register({
  type: "webhook",
  kind: "channel",
  label: "Webhook",
  icon: WebhookIcon,
  ConfigEditor: WebhookConfigEditor,
  StatusDisplay: WebhookStatusDisplay,
});
